import { Input } from '@/components/atoms/Form/Input';
import { Switch } from '@/components/atoms/Switch';
import { computeText } from '@/locales/utils';
import { formatDate } from '@/utils/date';

import {
    LoyaltyConfig,
    LoyaltyProgram,
    AuthenticationMethods,
    RegisterMethods,
    LoyaltyFeature,
} from '@/services/innovorder/modules/modules.type';
import React from 'react';
import { Control, Form } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { FormWrapper } from './ZerosixConfigUpdateForm.style';

export interface UpdateZerosixConfigForm {
    memberIdentifier: string;
    useCasualTone: boolean;
    authenticationMethods: AuthenticationMethods;
    registerMethods: RegisterMethods;
    features: LoyaltyFeature[];
}

const ZerosixConfigUpdateForm = ({
    control,
    loyaltyPrograms,
    loyaltyConfig,
}: {
    control: Control<UpdateZerosixConfigForm>;
    loyaltyPrograms?: LoyaltyProgram[];
    loyaltyConfig?: LoyaltyConfig;
}) => {
    const intl = useIntl();
    const { brandId, restaurantId } = useParams<{ brandId: string; restaurantId: string }>();

    return (
        <Form control={control}>
            <FormWrapper>
                <p>
                    {computeText(intl, 'zerosix.integrationEnabled', {
                        date: loyaltyConfig?.createdAt
                            ? formatDate(loyaltyConfig.createdAt, 'DD/MM/YYYY HH:mm:ss')
                            : '',
                    })}
                </p>

                <Controller
                    name="useCasualTone"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <Switch labelId="zerosix.useCasualTone" onChange={() => onChange(!value)} value={value} />
                    )}
                    defaultValue={loyaltyConfig?.useCasualTone}
                />
            </FormWrapper>
        </Form>
    );
};

export default ZerosixConfigUpdateForm;
